import type { Workout, WorkoutSet } from "./types.js";

export type NextWorkoutSet = {
  exerciseName: string;
  setNumber: number;
  details: string;
};

export function findNextWorkoutSet(workout: Workout): NextWorkoutSet | null {
  for (const exercise of workout.exercises) {
    const setIndex = exercise.sets.findIndex((set) => !set.completed);
    if (setIndex === -1) continue;
    return {
      exerciseName: exercise.name,
      setNumber: setIndex + 1,
      details: formatNextSetDetails(exercise.measurementType, exercise.sets[setIndex]!)
    };
  }
  return null;
}

export function formatNextSetDetails(
  measurementType: Workout["exercises"][number]["measurementType"],
  set: WorkoutSet
): string {
  const reps = set.targetReps ?? set.reps;
  if (measurementType === "duration") return `${formatNumber(set.seconds)} seconds`;
  if (measurementType === "distance") return `${formatNumber(set.distanceM)} m`;
  if (measurementType === "duration_power") return `${formatMinutes(set.seconds)} at ${formatNumber(set.averageWatts ?? null)} W average`;
  if (measurementType === "assisted_reps") return `${formatNumber(set.assistanceKg)} kg assistance × ${formatNumber(reps)} reps`;
  if (measurementType === "bodyweight_reps") return `Bodyweight × ${formatNumber(reps)} reps`;
  return `${formatNumber(set.weightKg)} kg × ${formatNumber(reps)} reps`;
}

function formatMinutes(seconds: number | null): string {
  if (seconds === null) return "— minutes";
  return `${formatNumber(seconds / 60)} minutes`;
}

function formatNumber(value: number | null): string {
  return value === null ? "—" : new Intl.NumberFormat("en-AU", { maximumFractionDigits: 2 }).format(value);
}
